import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="w-full bg-background-50 py-8 md:py-12">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-5">
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900">
            电影分类
          </h2>
          <Link
            to="/category/dongzuo"
            className="text-primary-500 text-xs font-medium hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
        <nav className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-10 gap-2 md:gap-3 stagger-children">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2 p-4 rounded-lg bg-background-100 hover:bg-primary-500 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 group-hover:bg-background-50/20 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <span className="text-foreground-700 group-hover:text-background-50 text-xs font-medium whitespace-nowrap transition-colors">
                {cat.name}
              </span>
            </Link>
          ))}
        </nav>
      </div>
    </section>
  );
}